








































































import { Component, Vue, Watch } from "vue-property-decorator";
import VChart from "../components/chart/VChart.vue";
import VChartRow from "../components/chart/VChartRow.vue";
import VChartBody from "../components/chart/VChartBody.vue";
import Chart from "../models/chart";
import { GridMask } from "../viewmodels/grid-mask";
import { eachDayOfInterval, isWeekend } from "date-fns";
import VChartHeader from "../components/chart/VChartCalendarHeader.vue";
import VGridMask from "../components/VGridMask.vue";
import VProxyWindow from "../components/VProxyWindow.vue";
import VGridRow from "../components/VGridRow.vue";
import { client } from "../api/request";
import ProjectCalendarApi, {
  SearchProjectCalendarQuery
} from "@/api/project/project-calendar-api";
import ProjectCalendarModel from "@/api/project/project-calendar";
import ProjectCalendarSearchBar from "../ui/project/components/ProjectCalendarSearchBar.vue";
import { ServiceRole, getServiceRoles } from "../api/service-api";
import { Company, getAllCompaniesByStatus } from "../api/company-api";
import SelectYearAndMonth from "../common/ui/components/SelectYearAndMonth.vue";
import Staff from "../entities/staff";
import StaffApi from "../api/staff-api";
import ProjectDetails from "../components/project/ProjectDetails.vue";
import {
  ProjectTaskChart,
  UserProjectCalendar
} from "@/entities/project-task-chart";
import { getTask, Task } from "@/api/task-api";
import TaskModal from "./TaskModal.vue";
import VToolbar from "@/components/V-Toolbar.vue";
import { getStatusCode } from "@/status";
import AppHeader from "./AppHeader.vue";

const calendarApi = new ProjectCalendarApi(client);

@Component({
  components: {
    VToolbar,
    TaskModal,
    ProjectDetails,
    SelectYearAndMonth,
    VProxyWindow,
    VGridMask,
    VGridRow,
    VChart,
    VChartRow,
    VChartBody,
    VChartHeader,
    ProjectCalendarSearchBar,
    AppHeader
  }
})
export default class ProjectCalendar extends Vue {
  chart = new Chart(new Date(), 10);
  companyOptions = [
    {
      text: "(自社・他社)",
      value: ""
    },
    {
      text: "自社",
      value: "1"
    },
    {
      text: "他社",
      value: "2"
    }
  ];

  isLoading: boolean = false;

  query: SearchProjectCalendarQuery = {
    staff: "",
    company: this.companyOptions[1] && this.companyOptions[1].value,
    role: "",
    status: getStatusCode("施工中"),
    companyList: ""
  };

  task: Task | null = null;
  taskOpen = false;
  invited = true;
  companyVendorList = [
    {
      text: "",
      value: ""
    }
  ];

  async clickBar(bar: { id: number }) {
    const task = await getTask(bar.id);
    this.task = task;
    this.taskOpen = true;
  }

  moveDate(year: number, month: number) {
    this.chart.moveDateByNumbers(year, month);
  }

  get staffOptions() {
    return [
      {
        text: "全て",
        value: ""
      }
    ].concat(
      this.staffs.map(s => ({
        text: s.name,
        value: String(s.id)
      }))
    );
  }

  get roleOptions() {
    return [
      {
        text: "(職種)",
        value: ""
      }
    ].concat(
      this.roles.map(r => ({
        text: r.name,
        value: String(r.id)
      }))
    );
  }

  companyList() {
    return [
      {
        text: "全て",
        value: ""
      }
    ].concat(
      this.companyLists.map(r => ({
        text: r.name,
        value: String(r.companyId)
      }))
    );
  }

  get users(): UserProjectCalendar[] {
    return this.calendars.map(u => ProjectTaskChart(u, this.chart));
  }

  get chartMask(): GridMask {
    return {
      cols: this.days.map(d =>
        isWeekend(d) ? { color: "rgba(0, 0, 0, 0.025)" } : {}
      )
    };
  }

  @Watch("roleOptions", { immediate: true })
  onDefaultQueryChanged() {
    const initialRoleOption = this.roleOptions.find(
      item => item.text === "管理者"
    );
    this.query = {
      ...this.query,
      role: initialRoleOption && initialRoleOption.value
    };
  }

  goNext() {
    this.chart.move(14);
  }

  goPrev() {
    this.chart.move(-14);
  }

  search(options: SearchProjectCalendarQuery, family?: string) {
    this.initProjectCalendarList(options);

    if (options.company == "1") {
      family = "1";
      this.query.company = "1";
    } else if (options.company == "2") {
      family = "2";
      this.query.company = "2";
    } else {
      family = "";
      this.query.company = "";
    }
    const new_options = {
      family: family,
      invited: this.invited
    };
    this.loadStaffList(new_options);
  }

  handleClickLink(id: number) {
    this.$router.push({ path: `/projects/${id}/tasks` });
  }

  protected created() {
    this.loadRoleList();
  }

  private calendars: ProjectCalendarModel[] = [];
  private roles: ServiceRole[] = [];
  private staffs: Staff[] = [];
  private companyLists: Company[] = [];

  get days(): Date[] {
    return eachDayOfInterval(this.chart);
  }

  private async initProjectCalendarList(
    query: SearchProjectCalendarQuery = {}
  ) {
    this.isLoading = true;

    if (query.company == "2") {
      query.role = "";
      this.companyLists = await getAllCompaniesByStatus({
        status: query.status
      });
      this.companyVendorList = this.companyList();
    } else {
      query.companyList = "";
    }

    try {
      this.calendars = (await calendarApi.all(query)).filter(
        c => c.projects.length > 0
      );
    } catch (e) {
      alert("応答に時間がかかっています。\nページを再読み込みしてください。");
      window.location.reload();
      return;
    } finally {
      this.isLoading = false;
    }
  }

  private async loadRoleList() {
    this.roles = await getServiceRoles();
  }

  private async loadStaffList(options?: { family: string; invited: boolean }) {
    this.staffs = await new StaffApi(client).getAll(options);
  }
}
